import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaAssignedAdvisorFound, schemaAssignedAdvisorNone } from '../../user/resolvers/shared/assignedAdvisor';

type Arguments = {
    loanRequestId: string;
};

export const schemaLoanRequestResolver_GetAssignedAdvisorForLead = z.discriminatedUnion('kind', [
    schemaAssignedAdvisorFound,
    schemaAssignedAdvisorNone,
]);

export type SchemaLoanRequestResolver_GetAssignedAdvisorForLead = z.infer<
    typeof schemaLoanRequestResolver_GetAssignedAdvisorForLead
>;

export type LoanRequestResolver_GetAssignedAdvisorForLead = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetAssignedAdvisorForLead
>;
